var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayApplePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 44.00 26.00",
    width: 44,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#989898",
    cx: 0,
    cy: 0,
    transform: "translate(8.95,7.36) rotate(131.5)",
    rx: 1.73,
    ry: 0.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: " M 18.39 15.25 L 18.38 18.23 Q 18.38 18.89 17.72 18.89 L 17.13 18.88 Q 16.49 18.87 16.49 18.23 L 16.49 7.29 Q 16.49 6.76 17.01 6.75 C 19.07 6.69 22.17 6.37 23.51 7.52 C 26.54 10.13 25.05 14.46 21.22 14.69 Q 19.15 14.81 19.09 14.82 Q 18.39 14.87 18.39 15.25 Z M 18.41 8.67 L 18.37 12.71 A 0.40 0.40 0.0 0 0 18.76 13.12 L 20.83 13.14 A 2.31 2.22 0.7 0 0 23.17 10.95 L 23.17 10.55 A 2.31 2.22 0.7 0 0 20.89 8.30 L 18.82 8.28 A 0.40 0.40 0.0 0 0 18.41 8.67 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: " M 8.32 9.52 Q 10.38 8.50 12.49 9.88 A 0.17 0.16 35.9 0 1 12.53 10.12 Q 9.95 13.54 12.66 15.41 Q 13.00 15.65 12.79 16.01 L 11.26 18.66 A 0.77 0.77 0.0 0 1 10.36 19.01 Q 7.94 18.27 5.60 18.99 Q 5.08 19.16 4.70 18.75 Q 2.46 16.30 2.27 13.23 C 2.07 10.13 4.28 8.29 7.34 9.55 Q 7.84 9.76 8.32 9.52 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: " M 31.44 12.79 Q 31.50 12.59 30.73 12.06 Q 28.90 10.77 27.86 12.08 Q 26.30 14.06 26.28 11.60 Q 26.27 10.99 27.72 10.43 Q 31.13 9.12 32.87 11.68 A 1.60 1.53 -62.9 0 1 33.13 12.55 L 33.13 18.32 A 0.55 0.54 -76.1 0 1 32.33 18.81 Q 31.28 18.26 30.17 18.51 Q 28.23 18.96 28.13 18.95 C 25.97 18.85 24.60 16.56 26.13 14.84 Q 27.02 13.84 29.94 13.88 A 1.54 1.54 0.0 0 0 31.44 12.79 Z M 31.2914 15.6305 A 2.03 1.25 -16.0 0 0 28.9955 14.9884 A 2.03 1.25 -16.0 0 0 27.3886 16.7495 A 2.03 1.25 -16.0 0 0 29.6845 17.3916 A 2.03 1.25 -16.0 0 0 31.2914 15.6305 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: " M 37.67 16.06 Q 38.06 17.32 38.45 16.06 L 40.11 10.67 Q 40.30 10.05 40.95 10.05 L 41.55 10.05 Q 42.31 10.05 42.05 10.77 Q 39.91 16.50 38.76 19.76 Q 37.79 22.50 35.07 22.19 A 0.44 0.43 -78.2 0 1 34.71 21.63 L 34.85 21.18 Q 34.97 20.80 35.36 20.74 Q 37.39 20.39 36.78 18.22 Q 36.65 17.75 34.12 10.75 Q 33.94 10.26 34.44 10.11 L 34.77 10.01 A 1.01 1.00 72.7 0 1 36.03 10.68 L 37.67 16.06 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayApplePay);
export default __webpack_public_path__ + "static/media/grayApplePay.b118ab3b9becc51fa8c24361d3e8812a.svg";
export { ForwardRef as ReactComponent };